const BaseImage = (props) => {
  return (
    <img
      src={props.src}
      alt={props.alt}
      className={props.className}
      height={props.height}
      width={props.width}
    />
  );
};

export default BaseImage;
